// The itemized-vs-flat tax fallback shared by the Generate Invoice review step
// and the printable Work Order documents — both render the same InvoicePreview
// shape. When per-tax rows exist, show one row per tax; otherwise a single
// "Tax" line. Callers own their own row styling; this only decides the rows.
export const invoicePreviewTaxRows = ({ itemizedTaxes = [], taxAmount = 0 }) =>
  itemizedTaxes.length > 0
    ? itemizedTaxes.map((tax) => ({
        key: `${tax.name}-${tax.rateDisplay}`,
        label: `${tax.name} (${tax.rateDisplay})`,
        amount: tax.amount,
      }))
    : [{ key: "tax", label: "Tax", amount: taxAmount }]
